export default __webpack_public_path__ + "static/media/photo-7@2x.e95abe3c.png";